<script>
    import app from "../stores/app";

    export let products;
    export let productsPrice;
    export let shippingPrice;
    export let codPrice;
    export let vatPrice = 0;
    export let vat = null;
    export let totalPrice;
</script>

{#if products}
    <div class="cart">
        {#each products as product}
            <div class="product">
                <div class="image">
                    {#if product.image}
                        <img src="{ $app.product_image_url }{ product.image }" alt="product image">
                    {:else}
                        <img src="/assets/images/product-logo.png" alt="product logo">
                    {/if}
                </div>
                <div class="content">
                    <div class="name">
                        { product.name }
                    </div>
                    <div class="price text-gray">
                        { product.quantity } x { product.price.toFixed(2) } €
                    </div>
                </div>
            </div>
        {/each}
        <hr>
        <div class="summary">
            <div class="name">Μερικό σύνολο</div>
            <div class="price">{ productsPrice.toFixed(2) } €</div>
        </div>
        {#if shippingPrice > 0}
            <div class="summary">
                <div class="name">Μεταφορικά</div>
                <div class="price text-gray">{ shippingPrice.toFixed(2) } €</div>
            </div>
        {/if}
        {#if codPrice > 0}
            <div class="summary">
                <div class="name">Έξοδα αντικαταβολής</div>
                <div class="price text-gray">{ codPrice.toFixed(2) } €</div>
            </div>
        {/if}
        {#if vatPrice > 0}
            <div class="summary">
                <div class="name">
                    Σύνολο Φ.Π.Α.
                    {#if vat}
                        ({ vat }%)
                    {/if}
                </div>
                <div class="price text-gray">{ vatPrice.toFixed(2) } €</div>
            </div>
        {/if}
        <hr>
        <div class="summary">
            <div class="name"><strong>Σύνολο</strong></div>
            <div class="price text-gray"><strong>{ totalPrice.toFixed(2) } €</strong></div>
        </div>
    </div>
{/if}

<style>
    .cart {

    }

    .cart .product {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }

    .cart .product .image {
        width: 60px;
    }

    .cart .product .image img {
        width: 100%;
    }

    .cart .product .content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding-left: 20px;
    }

    .cart .summary {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 5px 0;
    }

    @media (max-width: 576px) {
        .cart .product {
            margin: 15px 0;
        }

        .cart .product .image {
            width: 70px;
        }

        .cart .product .content {
            display: block;
            text-align: center;
            padding-left: 10px;
        }
    }
</style>